import {
  FaHome,
  FaInfoCircle,
  FaPlayCircle,
  FaTag,
  FaUserCircle,
  FaUserFriends,
  FaUsers,
  FaEnvelope,
  FaCalendarAlt,
  FaShareAlt,
  FaTrophy,
  FaMedal,
  FaSignal,
  FaChartLine,
  FaBookOpen,
  FaClipboardList,
  FaQuestionCircle,
  FaLanguage,
  FaGavel,
  FaDumbbell,
  FaShieldAlt,
  FaStopwatch,
  FaCheckCircle,
} from "react-icons/fa";

export const AUTH_ROLES = [1, 2, 3, 5, 6, 7];
export const COACH_ROLES = [1, 5, 6, 7];
export const ADMIN_ROLES = [1];

export const NAVBAR4_CATEGORIES = [
  {
    id: "discover",
    title: "Découvrir",
    subtitle: "Présentation de l’application",
    description:
      "Comprendre Judo Coach Pro avant de créer un compte ou de passer à l’espace coach.",
    accent: "blue",
    visitorOnly: true,
    items: [
      {
        key: "home",
        label: "Accueil",
        description: "Présentation générale de Judo Coach Pro",
        path: "/",
        roles: [],
        icon: FaHome,
      },
      {
        key: "features",
        label: "Judo Expert",
        description: "Voir les fonctionnalités gratuites accessibles aux judokas",
        path: "/judo-expert",
        roles: [],
        icon: FaInfoCircle,
      },
      {
        key: "coach-pro",
        label: "Espace coach",
        description: "Voir ce qu’un coach peut faire avec l’application",
        path: "/espace-coach",
        roles: [],
        icon: FaPlayCircle,
        featured: true,
      },
      {
        key: "pricing",
        label: "Formules & tarifs",
        description: "Découvrir les offres gratuites et coach",
        path: "/formules-tarifs",
        roles: [],
        icon: FaTag,
      },
    ],
  },
  {
    id: "space",
    title: "Mon espace",
    subtitle: "Compte, profil et messages",
    description:
      "Tout ce qui concerne ton compte, ton profil judoka, tes groupes et tes échanges.",
    accent: "blue",
    authOnly: true,
    items: [
      {
        key: "user-profile",
        label: "Profil utilisateur",
        description: "Mes informations de connexion et de compte",
        path: "/profile-utilisateur",
        roles: AUTH_ROLES,
        icon: FaUserCircle,
      },
      {
        key: "judoka-profile",
        label: "Profil judoka",
        description: "Grade, club, catégorie, informations sportives",
        path: "/profile-judoka",
        roles: AUTH_ROLES,
        icon: FaUserFriends,
      },
      {
        key: "join-group",
        label: "Rejoindre un groupe",
        description: "Entrer dans un groupe créé par un coach",
        path: "/join-group",
        roles: AUTH_ROLES,
        icon: FaUsers,
      },
      {
        key: "messages",
        label: "Mes messages",
        description: "Messages envoyés par les coachs ou l’application",
        path: "/messagerie-judoka",
        roles: AUTH_ROLES,
        icon: FaEnvelope,
        badgeKey: "unreadMessageCount",
      },
    ],
  },
  {
    id: "results",
    title: "Résultats & compétitions",
    subtitle: "Agenda, résultats et palmarès",
    description:
      "Gérer les compétitions, consulter les résultats et suivre le palmarès.",
    accent: "green",
    authOnly: true,
    items: [
      {
        key: "competitions",
        label: "Mes compétitions",
        description: "Les compétitions auxquelles je participe",
        path: "/events-judoka",
        roles: AUTH_ROLES,
        icon: FaCalendarAlt,
      },
      {
        key: "shared-events",
        label: "Compétitions partagées",
        description: "Événements proposés ou partagés avec moi",
        path: "/shared-events",
        roles: AUTH_ROLES,
        icon: FaShareAlt,
      },
      {
        key: "results",
        label: "Résultats",
        description: "Mes résultats de compétition",
        path: "/resultats",
        roles: AUTH_ROLES,
        icon: FaTrophy,
      },
      {
        key: "ranking",
        label: "Classement & palmarès",
        description: "Podiums, classements et historique",
        path: "/palmares",
        roles: AUTH_ROLES,
        icon: FaMedal,
      },
      {
        key: "preparation-physique-adherent",
        label: "Préparation physique",
        description: "Travail physique et exercices pour les judokas",
        path: "/preparation-physique-adherent",
        roles: AUTH_ROLES,
        icon: FaDumbbell,
      },
      {
        key: "stats",
        label: "Statistiques",
        description: "Indicateurs personnels de progression",
        path: "/statistiques-judoka",
        roles: AUTH_ROLES,
        icon: FaChartLine,
      },
    ],
  },
  {
    id: "grades",
    title: "Grades & révisions",
    subtitle: "Ceintures, techniques, kata et quizz",
    description:
      "Préparer les passages de grade, réviser les techniques et progresser entre les cours.",
    accent: "yellow",
    authOnly: true,
    items: [
      {
        key: "grading",
        label: "Passage de grade",
        description: "Suivi de la progression vers la prochaine ceinture",
        path: "/passage-grade",
        roles: AUTH_ROLES,
        icon: FaSignal,
        featured: true,
      },
      {
        key: "techniques-judo",
        label: "Révisions techniques",
        description: "Techniques, uv2, kata, quizz ...",
        path: "/techniques-judo",
        roles: AUTH_ROLES,
        icon: FaBookOpen,
      },

      {
        key: "lexique",
        label: "Lexique",
        description: "Vocabulaire japonais et termes du judo",
        path: "/lexique",
        roles: AUTH_ROLES,
        icon: FaLanguage,
      },
    ],
  },
  {
    id: "referee",
    title: "Arbitrage",
    subtitle: "Règlements, quizz et score",
    description:
      "Consulter les règles d’arbitrage, de commissaire sportif et accéder au tableau de score.",
    accent: "purple",
    authOnly: true,
    items: [
      {
        key: "arbitrage-judo",
        label: "Arbitrage Judo",
        description: "Règles essentielles du combat",
        path: "/arbitrage-judo",
        roles: AUTH_ROLES,
        icon: FaGavel,
      },

      {
        key: "scoreboard",
        label: "Tableau de score",
        description: "Accès rapide au tableau de score judo",
        path: "/judo-score",
        roles: [],
        icon: FaStopwatch,
      },
    ],
  },
  {
    id: "coach",
    title: "Espace coach",
    subtitle: "Groupes, suivi et progression",
    description:
      "Les outils pour créer des groupes, suivre les judokas et accompagner leur saison.",
    accent: "orange",
    authOnly: true,
    coachOnly: true,
    items: [
      {
        key: "groups-coach",
        label: "Mes groupes & invitations",
        description: "Créer, gérer et inviter les judokas",
        path: "/groups-coach",
        roles: COACH_ROLES,
        icon: FaUsers,
        badgeKey: "pendingRequestsCount",
        featured: true,
      },
      {
        key: "group-results",
        label: "Résultats & palmarès",
        description: "Suivre les résultats des groupes",
        path: "/group-results",
        roles: COACH_ROLES,
        icon: FaTrophy,
      },
      {
        key: "group-grading",
        label: "Passage de grade des judokas",
        description: "Suivre les ceintures et objectifs",
        path: "/passage-grade-coach",
        roles: COACH_ROLES,
        icon: FaSignal,
      },
      {
        key: "group-stats",
        label: "Statistiques des groupes",
        description: "Analyser la progression collective",
        path: "/statistiques-groupes-judoka",
        roles: COACH_ROLES,
        icon: FaChartLine,
      },
      {
        key: "group-attendance",
        label: "Présence des judokas",
        description: "Suivre la présence des judokas",
        path: "/attendance",
        roles: COACH_ROLES,
        icon: FaCheckCircle,
      },
      {
        key: "physical-preparation",
        label: "Préparation physique",
        description: "Attribuer du travail physique aux compétiteurs",
        path: "/preparation-physique-coach",
        roles: COACH_ROLES,
        icon: FaDumbbell,
        soon: true,
      },
    ],
  },
  {
    id: "admin",
    title: "Administration",
    subtitle: "Pilotage de l’application",
    description: "Accès administrateur aux outils de supervision.",
    accent: "red",
    authOnly: true,
    adminOnly: true,
    items: [
      {
        key: "admin-dashboard",
        label: "Dashboard admin",
        description: "Accès au tableau de bord administrateur",
        path: "/appli/dashboard",
        roles: ADMIN_ROLES,
        icon: FaShieldAlt,
      },
      {
        key: "contact-messages",
        label: "Messages de contact",
        description: "Demandes envoyées depuis les formulaires",
        path: "/appli/dashboard",
        roles: ADMIN_ROLES,
        icon: FaEnvelope,
        badgeKey: "unreadCountContactForm",
      },
    ],
  },
];

export const ACCENT_STYLES = {
  blue: {
    text: "text-sky-700 dark:text-sky-200",
    leftBorder: "border-l-[10px] border-sky-500",
    bg: "bg-sky-600",
    soft: "bg-sky-50 dark:bg-sky-500/10",
    border: "border-sky-200 dark:border-sky-400/20",
    gradient: "from-sky-600 to-blue-600",
    iconSoft: "bg-sky-100 text-sky-700 dark:bg-sky-500/15 dark:text-sky-200",
  },
  green: {
    text: "text-emerald-700 dark:text-emerald-200",
    leftBorder: "border-l-[10px] border-emerald-500",
    bg: "bg-emerald-600",
    soft: "bg-emerald-50 dark:bg-emerald-500/10",
    border: "border-emerald-200 dark:border-emerald-400/20",
    gradient: "from-emerald-600 to-teal-600",
    iconSoft:
      "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-200",
  },
  yellow: {
    text: "text-amber-700 dark:text-yellow-200",
    leftBorder: "border-l-[10px] border-amber-500",
    bg: "bg-amber-500",
    soft: "bg-amber-50 dark:bg-yellow-500/10",
    border: "border-amber-200 dark:border-yellow-400/20",
    gradient: "from-amber-500 to-yellow-400",
    iconSoft:
      "bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-yellow-200",
  },
  purple: {
    text: "text-violet-700 dark:text-violet-200",
    leftBorder: "border-l-[10px] border-violet-500",
    bg: "bg-violet-600",
    soft: "bg-violet-50 dark:bg-violet-500/10",
    border: "border-violet-200 dark:border-violet-400/20",
    gradient: "from-violet-600 to-fuchsia-600",
    iconSoft:
      "bg-violet-100 text-violet-700 dark:bg-violet-500/15 dark:text-violet-200",
  },
  orange: {
    text: "text-orange-700 dark:text-orange-200",
    leftBorder: "border-l-[10px] border-orange-500",
    bg: "bg-orange-600",
    soft: "bg-orange-50 dark:bg-orange-500/10",
    border: "border-orange-200 dark:border-orange-400/20",
    gradient: "from-orange-600 to-amber-500",
    iconSoft:
      "bg-orange-100 text-orange-700 dark:bg-orange-500/15 dark:text-orange-200",
  },
  red: {
    text: "text-red-700 dark:text-red-200",
    leftBorder: "border-l-[10px] border-red-500",
    bg: "bg-red-600",
    soft: "bg-red-50 dark:bg-red-500/10",
    border: "border-red-200 dark:border-red-400/20",
    gradient: "from-red-600 to-rose-600",
    iconSoft: "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-200",
  },
};

export const getBadgeValue = (item, counts = {}) => {
  if (!item?.badgeKey) return 0;
  return Number(counts[item.badgeKey] || 0);
};
